import Toggle from './Toggle';

// export types
export type { ToggleProps } from './Toggle';

// export components
export { Toggle };
export default Toggle;
